/* ═══════════════════════════════════════════════════
   NATIV NATURAL CARE — Global JS
   ECO LAB S.R.L. SB
═══════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {

  // ── Navbar scroll ────────────────────────────────
  const nav = document.getElementById('nav');
  if (nav) {
    const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Mobile menu ──────────────────────────────────
  const toggle  = document.getElementById('navToggle');
  const mob     = document.getElementById('mob-menu');
  const close   = document.getElementById('mobClose');
  if (toggle && mob) {
    toggle.addEventListener('click', () => mob.classList.add('open'));
    close?.addEventListener('click', () => mob.classList.remove('open'));
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') mob.classList.remove('open');
    });
  }

  // ── Scroll reveal ─────────────────────────────────
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.10 });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  // ── Parallax (hero bg) ───────────────────────────
  const parallaxEls = document.querySelectorAll('[data-parallax]');
  if (parallaxEls.length) {
    window.addEventListener('scroll', () => {
      const sy = window.scrollY;
      parallaxEls.forEach(el => {
        const factor = parseFloat(el.dataset.parallax) || 0.28;
        if (sy < window.innerHeight * 1.6) {
          el.style.transform = `translateY(${sy * factor}px)`;
        }
      });
    }, { passive: true });
  }

  // ── Form feedback ────────────────────────────────
  document.querySelectorAll('.nativ-form').forEach(form => {
    form.addEventListener('submit', e => {
      // Shopify gestisce il submit vero — questo è solo per il feedback visivo
      const btn = form.querySelector('.btn-submit');
      if (!btn) return;
      btn.dataset.original = btn.textContent;
      btn.textContent = 'Invio in corso…';
      btn.disabled = true;
    });
  });

  // ── Counter animazione numeri ────────────────────
  const counters = document.querySelectorAll('[data-count]');
  if (counters.length) {
    const cio = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        const el    = e.target;
        const target = parseFloat(el.dataset.count);
        const prefix = el.dataset.prefix || '';
        const suffix = el.dataset.suffix || '';
        const dec    = el.dataset.dec ? parseInt(el.dataset.dec) : 0;
        const dur    = 1600;
        const start  = performance.now();
        const tick = now => {
          const p = Math.min((now - start) / dur, 1);
          const ease = 1 - Math.pow(1 - p, 3);
          const val = target * ease;
          el.textContent = prefix + (dec ? val.toFixed(dec) : Math.floor(val)) + suffix;
          if (p < 1) requestAnimationFrame(tick);
          else el.textContent = prefix + (dec ? target.toFixed(dec) : target) + suffix;
        };
        requestAnimationFrame(tick);
        cio.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(el => cio.observe(el));
  }

});

